import { Routes, Route } from 'react-router-dom'
import React from 'react'
import ErrorBoundary from './shared/components/errorboundary/ErrorBoundary'
import NotFound from './shared/components/notfound/NotFound'
import BookingPage from './modules/unauthenticated/booking/BookingPage'
const AuthConatiner = React.lazy(() => import('./modules/unauthenticated/atz/AuthContainer'))

const AppPublicRoutes: React.FC = () => {
  return (
    <ErrorBoundary message="Page failed to load, please refresh your browser to try again.">
      <React.Suspense fallback={<></>}>
        <Routes>
          <Route path="/atz/*" element={<AuthConatiner />}>
            <Route path=":id" element={<AuthConatiner />} />
          </Route>
          <Route path="/booking/*" element={<BookingPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Suspense>
    </ErrorBoundary>
  )
}

export { AppPublicRoutes }
